import DOMPurify from 'dompurify';

export const extractFinalBody = (html = '') => {
  if (!html || typeof html !== 'string') return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  let body = doc.body;

  // If the response contains nested HTML documents, keep descending
  // until we reach the deepest <body> element.
  let nestedBody = body.querySelector('html body');
  while (nestedBody) {
    body = nestedBody;
    nestedBody = body.querySelector('html body');
  }

  return body?.innerHTML || html;
};

const scopeCss = (css = '', scope = '.html-content-root') => {
  if (!css) return '';

  return css.replace(/([^{}]+)(?=\s*\{)/g, (selectorText) => {
    const selector = selectorText.trim();
    if (!selector || selector.startsWith('@')) return selector;

    return selector
      .split(',')
      .map((rule) => {
        const trimmed = rule.trim();
        if (!trimmed) return '';
        if (trimmed.startsWith(scope)) return trimmed;
        return `${scope} ${trimmed}`;
      })
      .filter(Boolean)
      .join(', ');
  });
};

export const extractStyles = (html = '', scope = '.html-content-root') => {
  if (!html || typeof html !== 'string') return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const styleTags = Array.from(doc.querySelectorAll('style'));
  const rawStyles = styleTags
    .map((styleTag) => styleTag.textContent || '')
    .join('\n');

  return scopeCss(rawStyles, scope);
};

export const injectStylesOnce = (
  styles = '',
  styleId = 'html-content-styles',
) => {
  if (!styles || typeof document === 'undefined') return;

  const existing = document.getElementById(styleId);
  if (existing) {
    if (existing.innerHTML !== styles) {
      existing.innerHTML = styles;
    }
    return;
  }

  const styleTag = document.createElement('style');
  styleTag.id = styleId;
  styleTag.innerHTML = styles;
  document.head.appendChild(styleTag);
};

export const sanitizeHtml = (html = '') => {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html);
};
